
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"40","viewBox":"0 0 80 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 .104h41c21.54 0 39 17.461 39 39H4a4 4 0 01-4-4v-35z","fill":"#fff"}}),_c('path',{attrs:{"d":"M55 25.555H21m34 0l-6.452 6.55M55 25.554l-6.452-6.45","stroke":"#50AADF"}})])
          )
        }
      }
    